// Wider than RuntimeState: telemetry also reports states the runtime machine itself never enters.
export enum HeartbeatState {
  Starting = 'starting',
  Playing = 'playing',
  Offline = 'offline',
  AuthRecovering = 'auth-recovering',
  Empty = 'empty',
  Stalled = 'stalled'
}
